export const content = (state = window.XHS.content) => state;
